export class CommentConstants {
  public static readonly UISetting = {
    width: 640, // 64 * 10
    headerBarHeight: 40,
  };
}
